import { BannerType, ContentFulScreens, ICustomizedBanner, ICustomizedBannerAction, useAppDispatch } from "@next-platform/client-common-core";
import { BannerContentProps } from "@next-platform/client-common-spicy-ui";

import { useLocalizedNavigation } from "@/hooks/useLocalizedNavigation";

export interface IBannerProp extends BannerContentProps {
  name: string;
}
export interface ICmsBannerProps {
  placement: BannerType;
  shouldBeExcludedFromPagesWithTags?: boolean;
  className?: string;
  isVisibleOnPartner: boolean;
  isLayoutBanner?: boolean;
  availableBanners?: ICustomizedBanner[];
  screen?: ContentFulScreens;
}
export interface IBannerProps {
  className?: string;
  customizedBanners: BannerContentProps[];
  onOpenChange: () => void;
  shouldShowPopUpBanners: boolean;
  banners: ICustomizedBanner[];
  onUserViewedBanners: (banners: ICustomizedBanner[], contentfulScreen: ContentFulScreens) => void;
  bannerVariant: BannerType;
  isPreviewMode: boolean;
  contentFulScreen: ContentFulScreens;
}

export interface ICmsBannerService {
  banners: ICustomizedBanner[];
  dispatch: ReturnType<typeof useAppDispatch>;
  navigate: ReturnType<typeof useLocalizedNavigation>;
  onCTAClick: (banner: ICustomizedBanner, action: ICustomizedBannerAction, screen: string) => void;
  onPopUpCTAClick: () => Promise<void>;
  screen?: ContentFulScreens;
}
export enum ActionType {
  CTA = "CTA",
  Dismiss = "Dismiss",
}
